import React from "react";
import { Grid, Box, Link, Typography, IconButton } from "@mui/material";
import Image from "../Image";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { COLORS } from "../../constants";

const DesktopSiteFooter = ({ contactInfo, socialLinks, sections }) => (
  <Grid container spacing={2} sx={{ p: 2 }}>
    {/* Column 1: Logo, Address, Phone/Operational Times, Email */}
    <Grid item xs={12} md={3}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginTop: "-1.5rem",
        }}
      >
        <Image
          href="/"
          src="https://argusweb.azureedge.net/argus-web/logo.svg"
          alt="Logo"
          size={"xl"}
          sx={{ marginBottom: "1rem" }}
        />
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "0.75rem",
          }}
        >
          <LocationOnIcon
            sx={{
              fontSize: "1rem",
              marginRight: "0.5rem",
              marginTop: "0.1rem",
            }}
          />
          <Typography
            variant="caption"
            sx={{
              lineHeight: "1.5",
              whiteSpace: "pre-line",
              fontWeight: "200",
            }}
          >
            {contactInfo.address}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "0.75rem",
          }}
        >
          <PhoneIcon
            sx={{
              fontSize: "1rem",
              marginRight: "0.5rem",
              marginTop: "0.1rem",
            }}
          />
          <Typography
            variant="caption"
            sx={{
              lineHeight: "1.5",
              whiteSpace: "pre-line",
              fontWeight: "200",
            }}
          >
            {contactInfo.phone}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "flex-start" }}>
          <EmailIcon
            sx={{
              fontSize: "1rem",
              marginRight: "0.5rem",
              marginTop: "0.1rem",
            }}
          />
          <Typography
            variant="caption"
            sx={{ lineHeight: "1.5", fontWeight: "200" }}
          >
            {contactInfo.email}
          </Typography>
        </Box>
      </Box>
    </Grid>

    {/* Dynamic Sections */}
    {sections.map((section, index) => (
      <Grid item xs={12} md={2} key={index}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              marginBottom: "1rem",
              fontWeight: "400",
              textTransform: "uppercase",
            }}
          >
            {section.title}
          </Typography>
          {section.links.map((link, linkIndex) => (
            <Link
              key={linkIndex}
              href={link.href}
              color={COLORS.lightGray}
              underline="hover"
              variant="caption"
              sx={{
                marginBottom:
                  linkIndex < section.links.length - 1 ? "0.5rem" : 0,
                display: "block",
                fontWeight: "200",
              }}
            >
              {link.label}
            </Link>
          ))}
        </Box>
      </Grid>
    ))}

    {/* Column 5: Follow Us */}
    <Grid item xs={12} md={3}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            marginBottom: "1rem",
            fontWeight: "400",
            textTransform: "uppercase",
          }}
        >
          Follow Us
        </Typography>
        <Box sx={{ display: "flex", gap: "0.5rem", marginBottom: "1rem" }}>
          {socialLinks.map((social, index) => (
            <IconButton
              key={index}
              href={social.href}
              sx={{ padding: 0, color: "#fff" }}
            >
              {social.icon}
            </IconButton>
          ))}
        </Box>
      </Box>
    </Grid>
  </Grid>
);

export default DesktopSiteFooter;
